var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTotalContainer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 57,
    viewBox: "0 0 59 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img / container",
    clipPath: "url(#clip0_3886_66301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.9862 11.7184L17.6807 19.532L43.1518 32.2742L58.5146 24.488L32.9862 11.7184Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.7002 35.3634L43.1713 48.1844V32.2742L17.7002 19.532V35.3634Z",
    fill: "#426DB5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M58.5337 24.488V40.1949L43.1709 48.1843V32.2742L58.5337 24.488Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.0358 12.8225L20.1152 19.4184L43.3116 31.061L56.2809 24.488L33.0358 12.8225Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M57.509 26.2304L44.5566 32.895V46.3834L57.5525 39.63L57.509 26.2304Z",
    fill: "#426DB5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M50.875 29.4533V43.2219L52.0749 42.6725V28.6045L50.875 29.4533Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M19.4746 22.2787V34.3517L20.8028 35.0997V22.9764L19.4746 22.2787Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M22.0215 23.5706V35.6436L23.3507 36.3916V24.2692L22.0215 23.5706Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M24.5693 24.8625V36.9355L25.8975 37.6844V25.5611L24.5693 24.8625Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M27.1172 26.1553V38.2283L28.4454 38.9763V26.8539L27.1172 26.1553Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M29.665 27.4472V39.5202L30.9932 40.2691V28.1458L29.665 27.4472Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M32.2129 28.74V40.813L33.5411 41.561V29.4386L32.2129 28.74Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M34.7598 30.0319V42.1049L36.089 42.8538V30.7305L34.7598 30.0319Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M37.3076 31.3247V43.3977L38.6358 44.1457V32.0233L37.3076 31.3247Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M39.8555 32.6166V44.6896L41.1837 45.4385V33.3152L39.8555 32.6166Z",
    fill: "#47A7DE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M15.7724 20.1998L0.466797 28.0143L25.9379 40.7556L41.3018 32.9695L15.7724 20.1998Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M0.486328 43.8448L25.9575 56.6667V40.7556L0.486328 28.0143V43.8448Z",
    fill: "#083C87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M41.3209 32.9695V48.6773L25.957 56.6667V40.7556L41.3209 32.9695Z",
    fill: "#1C5DAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M15.823 21.304L2.90137 27.8998L26.0977 39.5425L39.0681 32.9695L15.823 21.304Z",
    fill: "#1C5DAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M40.2961 34.7127L27.3438 41.3764V54.8657L40.3385 48.1114L40.2961 34.7127Z",
    fill: "#083C87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M33.6611 37.9356V51.7033L34.8611 51.1548V37.0859L33.6611 37.9356Z",
    fill: "#1C5DAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M2.26074 30.7602V42.8331L3.59 43.5811V31.4588L2.26074 30.7602Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M4.80859 32.053V44.1259L6.1368 44.8739V32.7507L4.80859 32.053Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M7.35547 33.3448V45.4178L8.68367 46.1658V34.0434L7.35547 33.3448Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M9.90332 34.6367V46.7097L11.2326 47.4586V35.3353L9.90332 34.6367Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M12.4512 35.9296V48.0025L13.7794 48.7505V36.6282L12.4512 35.9296Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M14.999 37.2214V49.2944L16.3272 50.0433V37.92L14.999 37.2214Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M17.5469 38.5143V50.5872L18.8751 51.3352V39.2128L17.5469 38.5143Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M20.0938 39.8062V51.8791L21.422 52.628V40.5047L20.0938 39.8062Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M22.6416 41.099V53.1719L23.9709 53.9199V41.7976L22.6416 41.099Z",
    fill: "#4B86C6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M24.4082 0.333344L9.10156 8.14696L34.5727 20.8892L49.9366 13.103L24.4082 0.333344Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M9.12109 23.9784L34.5922 36.7994V20.8892L9.12109 8.14697V23.9784Z",
    fill: "#F49E22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M49.9557 13.103V28.8099L34.5918 36.7993V20.8892L49.9557 13.103Z",
    fill: "#F8B300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M24.4577 1.43753L11.5371 8.03342L34.7335 19.676L47.7028 13.103L24.4577 1.43753Z",
    fill: "#F8B300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M48.9309 14.8463L35.9785 21.51V34.9993L48.9743 28.245L48.9309 14.8463Z",
    fill: "#F49E22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M42.2969 18.0692V31.8369L43.4958 31.2884V17.2195L42.2969 18.0692Z",
    fill: "#F8B300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M10.8965 10.8937V22.9667L12.2247 23.7147V11.5923L10.8965 10.8937Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M13.4434 12.1856V24.2585L14.7716 25.0075V12.8842L13.4434 12.1856Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M15.9912 13.4784V25.5514L17.3194 26.2994V14.177L15.9912 13.4784Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M18.5391 14.7703V26.8433L19.8673 27.5913V15.4689L18.5391 14.7703Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M21.0859 16.0631V28.1361L22.4152 28.8841V16.7608L21.0859 16.0631Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M23.6348 17.355V29.428L24.963 30.176V18.0536L23.6348 17.355Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M26.1816 18.6478V30.7208L27.5098 31.4688V19.3455L26.1816 18.6478Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M28.7285 19.9397V32.0127L30.0578 32.7607V20.6383L28.7285 19.9397Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M31.2773 21.2316V33.3046L32.6055 34.0535V21.9302L31.2773 21.2316Z",
    fill: "#FBC85B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3886_66301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.0667,
    height: 56.3333,
    fill: "white",
    transform: "translate(0.466797 0.333344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTotalContainer);
export default __webpack_public_path__ + "static/media/icon-total-container.70977d42690d7405e398f3e6955cc514.svg";
export { ForwardRef as ReactComponent };